module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('h2', [_vm._v("UI icon")]), _vm._v(" "), _vm._l((_vm.uiIcons), function(icon) {
    return _c('div', {
      key: icon.name,
      staticClass: "ui-icon"
    }, [_c('div', {
      staticClass: "box mt--bg--neutrals-light-gray-01"
    }, [_c('mt-icon', {
      attrs: {
        "iconName": icon.name,
        "width": icon.width
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(icon.name))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _c('h2', [_vm._v("Pictogram")]), _vm._v(" "), _vm._l((_vm.pictograms), function(icon) {
    return _c('div', {
      key: icon.name,
      staticClass: "ui-icon"
    }, [_c('div', {
      staticClass: "box mt--bg--neutrals-light-gray-01"
    }, [_c('mt-icon', {
      attrs: {
        "iconName": icon.name,
        "width": icon.width
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(icon.name))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _c('h2', [_vm._v("Channel icon")]), _vm._v(" "), _vm._l((_vm.channelIcons), function(icon) {
    return _c('div', {
      key: icon.name,
      staticClass: "ui-icon"
    }, [_c('div', {
      staticClass: "box mt--bg--neutrals-light-gray-01"
    }, [_c('i', {
      class: ("mt-channel-icon mt-channel-icon--" + (icon.value) + "-initial")
    })]), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(icon.name))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _vm._l((_vm.channelIcons), function(icon) {
    return _c('div', {
      key: icon.name,
      staticClass: "ui-icon"
    }, [_c('div', {
      staticClass: "box mt--bg--neutrals-light-gray-01"
    }, [_c('i', {
      class: ("mt-channel-icon mt-channel-icon--" + (icon.value) + "-initial-disable")
    })]), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(icon.name))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _c('h2', [_vm._v("Channel logo")]), _vm._v(" "), _vm._l((_vm.channelIcons), function(icon) {
    return _c('div', {
      key: icon.name,
      staticClass: "ui-icon logo"
    }, [_c('div', {
      staticClass: "box mt--bg--neutrals-light-gray-01"
    }, [_c('i', {
      class: ("mt-channel-icon mt-channel-icon--" + (icon.value))
    })]), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(icon.name))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _vm._l((_vm.channelIcons), function(icon) {
    return _c('div', {
      key: icon.name,
      staticClass: "ui-icon logo"
    }, [_c('div', {
      staticClass: "box mt--bg--neutrals-light-gray-01"
    }, [_c('i', {
      class: ("mt-channel-icon mt-channel-icon--" + (icon.value) + "-disable")
    })]), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(icon.name))])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header-wrapper"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h1', [_vm._v("Iconography")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5842d42e","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Iconography.vue
// module id = CaRq
// module chunks = 0